import { useEffect, useCallback } from 'react';

// Хук для дополнительных функций и улучшений графика
export const useChartEnhancements = (
  chartRef,
  containerId,
  syncGroupId,
  localStorageVehicle,
  localStorageDateRange,
  getDataPoints,
  notifySelectionChanged
) => {
  // Функция для получения отладочной информации
  const getDebugInfo = useCallback(() => {
    return {
      containerId,
      syncGroupId,
      hasChart: !!chartRef.current,
      hasLocalVehicle: !!localStorageVehicle,
      hasLocalDateRange: !!localStorageDateRange,
      dataPointsCount: getDataPoints().length
    };
  }, [containerId, syncGroupId, chartRef, localStorageVehicle, localStorageDateRange, getDataPoints]);

  // Функция для экспорта состояния графика
  const exportChartState = useCallback(() => {
    const state = {
      containerId,
      syncGroupId,
      vehicle: localStorageVehicle,
      dateRange: localStorageDateRange,
      dataPoints: getDataPoints(),
      timestamp: new Date().toISOString()
    };
    
    const blob = new Blob([JSON.stringify(state, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `chart-state-${containerId}-${Date.now()}.json`;
    link.click();
    URL.revokeObjectURL(url);
  }, [containerId, syncGroupId, localStorageVehicle, localStorageDateRange, getDataPoints]);

  // Функция для принудительного уведомления о выделении
  const forceNotifySelection = useCallback((selectionData) => {
    console.log('BaseChart: Принудительное уведомление о выделении:', selectionData);
    if (notifySelectionChanged) {
      notifySelectionChanged(selectionData);
    }
  }, [notifySelectionChanged]);

  // Функция для анализа производительности
  const analyzePerformance = useCallback(() => {
    if (!chartRef.current) return null;
    
    const canvas = chartRef.current.canvas;
    const context = canvas.getContext('2d');
    
    return {
      canvasSize: {
        width: canvas.width,
        height: canvas.height
      },
      devicePixelRatio: window.devicePixelRatio,
      contextType: context.constructor.name,
      dataPointsCount: getDataPoints().length,
      memoryUsage: performance.memory ? {
        usedJSHeapSize: performance.memory.usedJSHeapSize,
        totalJSHeapSize: performance.memory.totalJSHeapSize,
        jsHeapSizeLimit: performance.memory.jsHeapSizeLimit
      } : 'недоступно'
    };
  }, [chartRef, getDataPoints]);

  // Эффект для мониторинга изменений localStorage
  useEffect(() => {
    if (localStorageVehicle) {
      console.log(`BaseChart Enhancement: Обнаружен транспорт из localStorage:`, localStorageVehicle.name);
    }
    if (localStorageDateRange) {
      console.log(`BaseChart Enhancement: Обнаружен диапазон дат из localStorage:`, 
        `${localStorageDateRange.startDate} - ${localStorageDateRange.endDate}`);
    }
  }, [localStorageVehicle, localStorageDateRange]);

  return {
    getDebugInfo,
    exportChartState,
    forceNotifySelection,
    analyzePerformance
  };
}; 